import { useDispatch } from "react-redux";
import classNames from "classnames";
import PropTypes from "prop-types";
import styles from "./GuidelinesGrid.module.scss";
import GuidelineMenuLink from "../Guideline/GuidelineMenuLink";
import { resetState } from "../../features/counter/counterSlice";
import { GUIDELINES_MENU_ITEMS } from "../../constants/navigation";

const GuidelinesGrid = ({
  variant = "dropdown", // "dropdown", "page", "overlay", "sidebar", "modal", "landing"
  onClose,
  showCloseButton = false,
  className = "",
  limitItems = null, // New prop to limit number of items shown
}) => {
  const dispatch = useDispatch();

  const handleClick = (item) => {
    dispatch(resetState());
    // Use window.location for direct navigation to avoid routing conflicts
    window.location.href = item.path;
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const itemsToShow = limitItems
    ? GUIDELINES_MENU_ITEMS.slice(0, limitItems)
    : GUIDELINES_MENU_ITEMS;

  const containerClass = classNames(styles.container, styles[`container--${variant}`], className);

  const headerClass = classNames(styles.header, styles[`header--${variant}`]);

  const contentClass = classNames(styles.content, styles[`content--${variant}`]);

  const guidelineListClass = classNames(
    "list-unstyled",
    "guideline-areas",
    styles.guidelineList,
    styles[`guidelineList--${variant}`],
  );

  return (
    <div className={containerClass}>
      {showCloseButton && (
        <div className={headerClass}>
          <h2 className={styles.title}>Guidelines</h2>
          <button
            className={styles.closeButton}
            onClick={handleClose}
            aria-label="Close Guidelines"
          >
            <i className="tg-icons-Cross"></i>
          </button>
        </div>
      )}

      <div className={contentClass}>
        <ul className={guidelineListClass} role="navigation" aria-label="Guidelines Navigation">
          {itemsToShow.map((item, index) => (
            <li key={`guideline-${index}`}>
              <GuidelineMenuLink
                iconClassSuffix={item.iconClassSuffix}
                linkText={item.title}
                showArrowIcon={true}
                onClickAction={() => handleClick(item)}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

GuidelinesGrid.propTypes = {
  variant: PropTypes.oneOf(["dropdown", "page", "overlay", "sidebar", "modal", "landing"])
    .isRequired,
  showCloseButton: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.string,
  limitItems: PropTypes.number,
};

export default GuidelinesGrid;
